import { Event } from '~/Features/Messaging/types';

export class CampusApplicationEvent extends Event {
    constructor(
        public readonly currentChoicesNumber: number,
        id: string
    ) {
        super(id);
    }
}

export class CampusApplicationItemRemoved extends CampusApplicationEvent {
    public static readonly id = 'CampusApplicationItemRemoved';

    constructor(currentChoicesNumber: number) {
        super(currentChoicesNumber, CampusApplicationItemRemoved.id);
    }
}

export class CampusApplicationItemAdded extends CampusApplicationEvent {
    public static readonly id = 'CampusApplicationItemAdded';

    constructor(currentChoicesNumber: number) {
        super(currentChoicesNumber, CampusApplicationItemAdded.id);
    }
}

export class AddingExistingItemAttempt extends CampusApplicationEvent {
    public static readonly id = 'AddingExistingItemAttempt';

    constructor(currentChoicesNumber: number) {
        super(currentChoicesNumber, AddingExistingItemAttempt.id);
    }
}

export class AddingAnotherOptionAttempt extends CampusApplicationEvent {
    public static readonly id = 'AddingAnotherOptionAttempt';

    constructor(currentChoicesNumber: number) {
        super(currentChoicesNumber, AddingAnotherOptionAttempt.id);
    }
}

export class MaxNumberOfChoicesExceeded extends CampusApplicationEvent {
    public static readonly id = 'MaxNumberOfChoicesExceeded';

    constructor(maxChoicesNumber: number) {
        super(maxChoicesNumber, MaxNumberOfChoicesExceeded.id);
    }
}
